import React, { useEffect, useState } from "react";
import { Chart } from "primereact/chart";
import {
  getProductionDashboard,
  /*getInventoryTurnoverSummary,
  getOrderFulfillmentSummary,
  getStockOpnameSummary,
  getStockValueSummary,
  getTopStockQuantitySummary,
  getTopStockReorderSummary,
  getTopStockValueSummary,*/
} from "../../../../services/production/productionReportService";
import DialogLayout from "../../../../partials/content/DialogLayout";
import SearchFiscalYear from "../../setup/finance/searchFiscalYear";
import SearchFiscalPeriod from "../../setup/finance/searchFiscalPeriod";
import { DialogActions, IconButton, Typography } from "@material-ui/core";
import { Search } from "@mui/icons-material";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import {
  abbrMonthName,
  abbrNum,
  formatPercent,
  ratioFormat,
} from "../../../../utils/utils";
import { DateTime } from "luxon";

function ProductionDashboard(props) {
  const {
    companyProfile,
    currentFiscalYear,
    currentFiscalPeriod,
    reload,
  } = useGlobalData();
  /*const [
    openSearchFiscalYearStockValue,
    setOpenSearchFiscalYearStockValue,
  ] = useState(false);
  const [
    openSearchFiscalYearOrderFulfillment,
    setOpenSearchFiscalYearOrderFulfillment,
  ] = useState(false);
  const [
    openSearchFiscalYearInventoryTurnover,
    setOpenSearchFiscalYearInventoryTurnover,
  ] = useState(false);
  const [
    openSearchFiscalYearStockOpname,
    setOpenSearchFiscalYearStockOpname,
  ] = useState(false);
  const [openSearchFiscalYear, setOpenSearchFiscalYear] = useState(false);
  const [
    openSearchFiscalPeriodTopStockValue,
    setOpenSearchFiscalPeriodTopStockValue,
  ] = useState(false);
  const [
    openSearchFiscalPeriodTopStockReorder,
    setOpenSearchFiscalPeriodTopStockReorder,
  ] = useState(false);
  const [
    openSearchFiscalPeriodTopStockQuantity,
    setOpenSearchFiscalPeriodTopStockQuantity,
  ] = useState(false);
  const [openSearchFiscalPeriod, setOpenSearchFiscalPeriod] = useState(false);
  const [fiscalYearStockValue, setFiscalYearStockValue] = useState(
    currentFiscalYear.ID > 0
      ? currentFiscalYear
      : {
          ID: 0,
          year: 0,
          yearTo: 0,
          startMonth: 0,
          startMonthName: "",
          endMonth: 0,
          endMonthName: "",
        }
  );
  const [fiscalYearOrderFulfillment, setFiscalYearOrderFulfillment] = useState(
    currentFiscalYear.ID > 0
      ? currentFiscalYear
      : {
          ID: 0,
          year: 0,
          yearTo: 0,
          startMonth: 0,
          startMonthName: "",
          endMonth: 0,
          endMonthName: "",
        }
  );
  const [
    fiscalYearInventoryTurnover,
    setFiscalYearInventoryTurnover,
  ] = useState(
    currentFiscalYear.ID > 0
      ? currentFiscalYear
      : {
          ID: 0,
          year: 0,
          yearTo: 0,
          startMonth: 0,
          startMonthName: "",
          endMonth: 0,
          endMonthName: "",
        }
  );
  const [fiscalYearStockOpname, setFiscalYearStockOpname] = useState(
    currentFiscalYear.ID > 0
      ? currentFiscalYear
      : {
          ID: 0,
          year: 0,
          yearTo: 0,
          startMonth: 0,
          startMonthName: "",
          endMonth: 0,
          endMonthName: "",
        }
  );
  const [fiscalPeriodTopStockValue, setFiscalPeriodTopStockValue] = useState(
    currentFiscalPeriod.ID > 0
      ? currentFiscalPeriod
      : {
          ID: 0,
          fiscalYearID: 0,
          year: DateTime.now().year,
          month: DateTime.now().month,
          monthName: DateTime.now().toLocaleString({
            month: "long",
          }),
          statusID: 0,
        }
  );
  const [
    fiscalPeriodTopStockReorder,
    setFiscalPeriodTopStockReorder,
  ] = useState(
    currentFiscalPeriod.ID > 0
      ? currentFiscalPeriod
      : {
          ID: 0,
          fiscalYearID: 0,
          year: DateTime.now().year,
          month: DateTime.now().month,
          monthName: DateTime.now().toLocaleString({
            month: "long",
          }),
          statusID: 0,
        }
  );
  const [
    fiscalPeriodTopStockQuantity,
    setFiscalPeriodTopStockQuantity,
  ] = useState(
    currentFiscalPeriod.ID > 0
      ? currentFiscalPeriod
      : {
          ID: 0,
          fiscalYearID: 0,
          year: DateTime.now().year,
          month: DateTime.now().month,
          monthName: DateTime.now().toLocaleString({
            month: "long",
          }),
          statusID: 0,
        }
  );

  const [fillRateData, setFillRateData] = useState({
    datasets: [],
    fillRate: 0,
  });
  const [backorderRateData, setBackorderRateData] = useState({
    datasets: [],
    backorderRate: 0,
  });
  const [returnRateData, setReturnRateData] = useState({
    datasets: [],
    returnRate: 0,
  });
  const [accuracyRateData, setAccuracyRateData] = useState({
    datasets: [],
    accuracyRate: 0,
  });
  const [safeStockRateData, setSafeStockRateData] = useState({
    datasets: [],
    safeStockRate: 0,
  });
  const [turnoverRatioData, setTurnoverRatioData] = useState({
    datasets: [],
    turnoverRatio: 0,
  });
  const [totalStockCurrentValue, setTotalStockCurrentValue] = useState(0);
  const [totalProducts, setTotalProducts] = useState(0);
  const [
    totalAverageFulfillmentTime,
    setTotalAverageFulfillmentTime,
  ] = useState(0);
  const [totalAverageDaysToSell, setTotalAverageDaysToSell] = useState(0);

  const fillRateSummaryData = {
    datasets: fillRateData.datasets,
  };

  const fillRateSummaryOptions = {
    aspectRatio: 2,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        yAlign: "bottom",
        displayColors: false,
        callbacks: {
          label: function(tooltipItem, data, value) {
            if (tooltipItem.dataset.needleValue >= 90) {
              return `In Good condition`;
            } else if (
              tooltipItem.dataset.needleValue >= 80 &&
              tooltipItem.dataset.needleValue < 90
            ) {
              return `In Worrying condition`;
            } else if (tooltipItem.dataset.needleValue < 80) {
              return `In Bad condition`;
            }
          },
        },
      },
    },
  };

  const fillRateSummaryPlugins = {
    id: "fillRateSummaryPlugins",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      if (fillRateData.datasets.length > 0) {
        const { ctx } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
        const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
        const width = outerRadius - innerRadius;
        const angle = Math.PI / 180;

        ctx.beginPath();
        ctx.lineWidth = width - 2;
        ctx.strokeStyle = "#6c7293";
        ctx.arc(xCoor, yCoor, outerRadius - width / 2, 0, angle * 360, false);
        ctx.stroke();
      }
    },
  };

  const backorderRateSummaryData = {
    datasets: backorderRateData.datasets,
  };

  const backorderRateSummaryOptions = {
    aspectRatio: 2,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        yAlign: "bottom",
        displayColors: false,
        callbacks: {
          label: function(tooltipItem, data, value) {
            if (tooltipItem.dataset.needleValue <= 10) {
              return `In Good condition`;
            } else if (
              tooltipItem.dataset.needleValue > 10 &&
              tooltipItem.dataset.needleValue <= 20
            ) {
              return `In Worrying condition`;
            } else if (tooltipItem.dataset.needleValue > 20) {
              return `In Bad condition`;
            }
          },
        },
      },
    },
  };

  const backorderRateSummaryPlugins = {
    id: "backorderRateSummaryPlugins",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      if (backorderRateData.datasets.length > 0) {
        const { ctx } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
        const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
        const width = outerRadius - innerRadius;
        const angle = Math.PI / 180;

        ctx.beginPath();
        ctx.lineWidth = width - 2;
        ctx.strokeStyle = "#6c7293";
        ctx.arc(xCoor, yCoor, outerRadius - width / 2, 0, angle * 360, false);
        ctx.stroke();
      }
    },
  };

  const returnRateSummaryData = {
    datasets: returnRateData.datasets,
  };

  const returnRateSummaryOptions = {
    aspectRatio: 2,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        yAlign: "bottom",
        displayColors: false,
        callbacks: {
          label: function(tooltipItem, data, value) {
            if (tooltipItem.dataset.needleValue <= 10) {
              return `In Good condition`;
            } else if (
              tooltipItem.dataset.needleValue > 10 &&
              tooltipItem.dataset.needleValue <= 20
            ) {
              return `In Worrying condition`;
            } else if (tooltipItem.dataset.needleValue > 20) {
              return `In Bad condition`;
            }
          },
        },
      },
    },
  };

  const returnRateSummaryPlugins = {
    id: "returnRateSummaryPlugins",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      if (returnRateData.datasets.length > 0) {
        const { ctx } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
        const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
        const width = outerRadius - innerRadius;
        const angle = Math.PI / 180;

        ctx.beginPath();
        ctx.lineWidth = width - 2;
        ctx.strokeStyle = "#6c7293";
        ctx.arc(xCoor, yCoor, outerRadius - width / 2, 0, angle * 360, false);
        ctx.stroke();
      }
    },
  };

  const accuracyRateSummaryData = {
    datasets: accuracyRateData.datasets,
  };

  const accuracyRateSummaryOptions = {
    aspectRatio: 2,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        yAlign: "bottom",
        displayColors: false,
        callbacks: {
          label: function(tooltipItem, data, value) {
            if (tooltipItem.dataset.needleValue >= 90) {
              return `In Good condition`;
            } else if (
              tooltipItem.dataset.needleValue >= 80 &&
              tooltipItem.dataset.needleValue < 90
            ) {
              return `In Worrying condition`;
            } else if (tooltipItem.dataset.needleValue < 80) {
              return `In Bad condition`;
            }
          },
        },
      },
    },
  };

  const accuracyRateSummaryPlugins = {
    id: "accuracyRateSummaryPlugins",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      if (accuracyRateData.datasets.length > 0) {
        const { ctx } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
        const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
        const width = outerRadius - innerRadius;
        const angle = Math.PI / 180;

        ctx.beginPath();
        ctx.lineWidth = width - 2;
        ctx.strokeStyle = "#6c7293";
        ctx.arc(xCoor, yCoor, outerRadius - width / 2, 0, angle * 360, false);
        ctx.stroke();
      }
    },
  };

  const safeStockRateSummaryData = {
    datasets: safeStockRateData.datasets,
  };

  const safeStockRateSummaryOptions = {
    aspectRatio: 2,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        yAlign: "bottom",
        displayColors: false,
        callbacks: {
          label: function(tooltipItem, data, value) {
            if (tooltipItem.dataset.needleValue >= 80) {
              return `In Good condition`;
            } else if (
              tooltipItem.dataset.needleValue >= 60 &&
              tooltipItem.dataset.needleValue < 80
            ) {
              return `In Worrying condition`;
            } else if (tooltipItem.dataset.needleValue < 60) {
              return `In Bad condition`;
            }
          },
        },
      },
    },
  };

  const safeStockRateSummaryPlugins = {
    id: "safeStockRateSummaryPlugins",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      if (safeStockRateData.datasets.length > 0) {
        const { ctx } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
        const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
        const width = outerRadius - innerRadius;
        const angle = Math.PI / 180;

        ctx.beginPath();
        ctx.lineWidth = width - 2;
        ctx.strokeStyle = "#6c7293";
        ctx.arc(xCoor, yCoor, outerRadius - width / 2, 0, angle * 360, false);
        ctx.stroke();
      }
    },
  };

  const turnoverRatioSummaryData = {
    datasets: turnoverRatioData.datasets,
  };

  const turnoverRatioSummaryOptions = {
    aspectRatio: 2,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        yAlign: "bottom",
        displayColors: false,
        callbacks: {
          label: function(tooltipItem, data, value) {
            if (tooltipItem.dataset.needleValue >= 2) {
              return `In Good condition`;
            } else if (
              tooltipItem.dataset.needleValue >= 1 &&
              tooltipItem.dataset.needleValue < 2
            ) {
              return `In Worrying condition`;
            } else if (tooltipItem.dataset.needleValue < 1) {
              return `In Bad condition`;
            }
          },
        },
      },
    },
  };

  const turnoverRatioSummaryPlugins = {
    id: "turnoverRatioSummaryPlugins",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      if (turnoverRatioData.datasets.length > 0) {
        const { ctx } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
        const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
        const width = outerRadius - innerRadius;
        const angle = Math.PI / 180;

        ctx.beginPath();
        ctx.lineWidth = width - 2;
        ctx.strokeStyle = "#6c7293";
        ctx.arc(xCoor, yCoor, outerRadius - width / 2, 0, angle * 360, false);
        ctx.stroke();
      }
    },
  };

  const [stockValueSummaryData, setStockValueSummaryData] = useState({
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        type: "line",
        label: "All Stock Value",
        borderColor: "#12b18c",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        type: "bar",
        label: "Good Stock Value",
        backgroundColor: "#0096ec",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        borderColor: "white",
        borderWidth: 2,
        borderRadius: 10,
      },
      {
        type: "bar",
        label: "Expired Stock Value",
        backgroundColor: "#f1416c",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        borderColor: "white",
        borderWidth: 2,
        borderRadius: 10,
      },
      {
        type: "bar",
        label: "No Expiry Stock Value",
        backgroundColor: "#6c7293",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        borderColor: "white",
        borderWidth: 2,
        borderRadius: 10,
      },
    ],
  });

  const stockValueSummaryOptions = {
    maintainAspectRatio: false,
    aspectRatio: 1,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.dataset.label}: ${companyProfile.currency.currencyCode} ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#6c7293",
        },
        grid: {
          color: "#ebedef",
        },
      },
      y: {
        ticks: {
          color: "#6c7293",
          callback: (value, index, values) => {
            return abbrNum(value, 2);
          },
        },
        grid: {
          color: "#ebedef",
        },
      },
    },
  };

  const [
    orderFulfillmentSummaryData,
    setOrderFulfillmentSummaryData,
  ] = useState({
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        type: "bar",
        label: "Fill Rate",
        backgroundColor: "#12b18c",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        borderColor: "white",
        borderWidth: 2,
        borderRadius: 10,
      },
      {
        type: "bar",
        label: "Backorder Rate",
        backgroundColor: "#fd7e14",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        borderColor: "white",
        borderWidth: 2,
        borderRadius: 10,
      },
      {
        type: "bar",
        label: "Return Rate",
        backgroundColor: "#f1416c",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        borderColor: "white",
        borderWidth: 2,
        borderRadius: 10,
      },
    ],
  });

  const orderFulfillmentSummaryOptions = {
    maintainAspectRatio: false,
    aspectRatio: 1,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.dataset.label}: ${tooltipItem.formattedValue}%`;
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#6c7293",
        },
        grid: {
          color: "#ebedef",
        },
      },
      y: {
        ticks: {
          color: "#6c7293",
          callback: (value, index, values) => {
            return abbrNum(value, 2);
          },
        },
        grid: {
          color: "#ebedef",
        },
      },
    },
  };

  const [stockQuantitySummaryAmount, setStockQuantitySummaryAmount] = useState({
    totalStockQuantity: 0,
  });
  const [stockQuantitySummaryData, setStockQuantitySummaryData] = useState({
    labels: ["Stock Quantity"],
    datasets: [
      {
        type: "bar",
        label: "On-Hand",
        backgroundColor: "#12b18c",
        data: [0],
        borderColor: "white",
        borderWidth: 2,
        borderRadius: 10,
      },
      {
        type: "bar",
        label: "In-Transit",
        backgroundColor: "#6610f2",
        data: [0],
        borderColor: "white",
        borderWidth: 2,
        borderRadius: 10,
      },
    ],
  });

  const stockQuantitySummaryOptions = {
    indexAxis: "y",
    maintainAspectRatio: false,
    aspectRatio: 3.5,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.dataset.label}: ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: {
          color: "#6c7293",
          callback: (value, index, values) => {
            return abbrNum(value, 2);
          },
        },
        grid: {
          color: "#ebedef",
        },
      },
      y: {
        stacked: true,
        ticks: {
          color: "#6c7293",
          display: false,
        },
        grid: {
          color: "#ebedef",
          display: false,
        },
      },
    },
  };

  const [
    inventoryStatusSummaryAmount,
    setInventoryStatusSummaryAmount,
  ] = useState({
    totalProduct: 0,
  });
  const [inventoryStatusSummaryData, setInventoryStatusSummaryData] = useState({
    labels: ["Inventory Status"],
    datasets: [
      {
        type: "bar",
        label: "Safe Stock",
        backgroundColor: "#12b18c",
        data: [0],
        borderColor: "white",
        borderWidth: 2,
        borderRadius: 10,
      },
      {
        type: "bar",
        label: "Low Stock",
        backgroundColor: "#fd7e14",
        data: [0],
        borderColor: "white",
        borderWidth: 2,
        borderRadius: 10,
      },
      {
        type: "bar",
        label: "Out of Stock",
        backgroundColor: "#f1416c",
        data: [0],
        borderColor: "white",
        borderWidth: 2,
        borderRadius: 10,
      },
    ],
  });

  const inventoryStatusSummaryOptions = {
    indexAxis: "y",
    maintainAspectRatio: false,
    aspectRatio: 3.5,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.dataset.label}: ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: {
          color: "#6c7293",
          callback: (value, index, values) => {
            return abbrNum(value, 2);
          },
        },
        grid: {
          color: "#ebedef",
        },
      },
      y: {
        stacked: true,
        ticks: {
          color: "#6c7293",
          display: false,
        },
        grid: {
          color: "#ebedef",
          display: false,
        },
      },
    },
  };

  const [topStockValueSummaryData, setTopStockValueSummaryData] = useState({
    labels: ["", "", "", "", ""],
    datasets: [
      {
        data: [0, 0, 0, 0, 0],
        backgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
        hoverBackgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
      },
    ],
  });

  const topStockValueSummaryOptions = {
    aspectRatio: 2.5,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "left",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.label}: ${companyProfile.currency.currencyCode} ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
  };

  const topStockValueSummaryPlugins = {
    id: "topStockValueSummaryPlugins",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      if (topStockValueSummaryData.datasets.length > 0) {
        const { ctx } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
        const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
        const width = outerRadius - innerRadius;
        const angle = Math.PI / 180;

        ctx.beginPath();
        ctx.lineWidth = width - 2;
        ctx.strokeStyle = "#6c7293";
        ctx.arc(xCoor, yCoor, outerRadius - width / 2, 0, angle * 360, false);
        ctx.stroke();
      }
    },
  };

  const [topStockReorderSummaryData, setTopStockReorderSummaryData] = useState({
    labels: ["", "", "", "", ""],
    datasets: [
      {
        data: [0, 0, 0, 0, 0],
        backgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
        hoverBackgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
      },
    ],
  });

  const topStockReorderSummaryOptions = {
    aspectRatio: 2.5,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "left",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.label}: ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
  };

  const topStockReorderSummaryPlugins = {
    id: "topStockReorderSummaryPlugins",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      if (topStockReorderSummaryData.datasets.length > 0) {
        const { ctx } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
        const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
        const width = outerRadius - innerRadius;
        const angle = Math.PI / 180;

        ctx.beginPath();
        ctx.lineWidth = width - 2;
        ctx.strokeStyle = "#6c7293";
        ctx.arc(xCoor, yCoor, outerRadius - width / 2, 0, angle * 360, false);
        ctx.stroke();
      }
    },
  };

  const [
    topStockQuantitySummaryData,
    setTopStockQuantitySummaryData,
  ] = useState({
    labels: ["", "", "", "", ""],
    datasets: [
      {
        data: [0, 0, 0, 0, 0],
        backgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
        hoverBackgroundColor: [
          "#12b18c",
          "#0096ec",
          "#6610f2",
          "#fd7e14",
          "#f1416c",
        ],
      },
    ],
  });

  const topStockQuantitySummaryOptions = {
    aspectRatio: 2.5,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "left",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.label}: ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
  };

  const topStockQuantitySummaryPlugins = {
    id: "topStockQuantitySummaryPlugins",
    beforeDatasetsDraw(chart, args, pluginOptions) {
      if (topStockQuantitySummaryData.datasets.length > 0) {
        const { ctx } = chart;
        ctx.save();
        const xCoor = chart.getDatasetMeta(0).data[0].x;
        const yCoor = chart.getDatasetMeta(0).data[0].y;
        const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
        const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
        const width = outerRadius - innerRadius;
        const angle = Math.PI / 180;

        ctx.beginPath();
        ctx.lineWidth = width - 2;
        ctx.strokeStyle = "#6c7293";
        ctx.arc(xCoor, yCoor, outerRadius - width / 2, 0, angle * 360, false);
        ctx.stroke();
      }
    },
  };

  const [
    inventoryTurnoverSummaryData,
    setInventoryTurnoverSummaryData,
  ] = useState({
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        type: "line",
        label: "Inventory Turnover",
        borderColor: "#12b18c",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    ],
  });

  const inventoryTurnoverSummaryOptions = {
    maintainAspectRatio: false,
    aspectRatio: 2.2,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.dataset.label}: ${companyProfile.currency.currencyCode} ${tooltipItem.formattedValue}`;
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#6c7293",
        },
        grid: {
          color: "#ebedef",
        },
      },
      y: {
        ticks: {
          color: "#6c7293",
          callback: (value, index, values) => {
            return abbrNum(value, 2);
          },
        },
        grid: {
          color: "#ebedef",
        },
      },
    },
  };

  const [stockOpnameSummaryData, setStockOpnameSummaryData] = useState({
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        type: "line",
        label: "Accuracy Rate",
        borderColor: "#12b18c",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        type: "line",
        label: "Surplus Rate",
        borderColor: "#6610f2",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      {
        type: "line",
        label: "Deficit Rate",
        borderColor: "#f1416c",
        borderWidth: 2,
        fill: false,
        tension: 0,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    ],
  });

  const stockOpnameSummaryOptions = {
    maintainAspectRatio: false,
    aspectRatio: 2.2,
    plugins: {
      legend: {
        labels: {
          color: "#6c7293",
          usePointStyle: true,
          pointStyle: "rectRounded",
        },
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem, data, value) {
            return `${tooltipItem.dataset.label}: ${tooltipItem.formattedValue}%`;
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#6c7293",
        },
        grid: {
          color: "#ebedef",
        },
      },
      y: {
        ticks: {
          color: "#6c7293",
          callback: (value, index, values) => {
            return abbrNum(value, 2);
          },
        },
        grid: {
          color: "#ebedef",
        },
      },
    },
  };

  async function getInventoryDashboardData(
    fiscalYearID = 0,
    fiscalPeriodID = 0
  ) {
    const response = await getInventoryDashboard(fiscalYearID, fiscalPeriodID);
    const { data } = response.data;
    const {
      fillRate,
      datasetsFillRate,
      backorderRate,
      datasetsBackorderRate,
      returnRate,
      datasetsReturnRate,
      accuracyRate,
      datasetsAccuracyRate,
      safeStockRate,
      datasetsSafeStockRate,
      turnoverRatio,
      datasetsTurnoverRatio,
      totalStockCurrentValue,
      totalProducts,
      totalAverageFulfillmentTime,
      totalAverageDaysToSell,
      stockValueSummary,
      orderFulfillmentSummary,
      stockQuantitySummary,
      inventoryStatusSummary,
      topStockValueSummary,
      topStockReorderSummary,
      topStockQuantitySummary,
      inventoryTurnoverSummary,
      stockOpnameSummary,
    } = data;
    setFillRateData({
      datasets: datasetsFillRate,
      fillRate: fillRate,
    });
    setBackorderRateData({
      datasets: datasetsBackorderRate,
      backorderRate: backorderRate,
    });
    setReturnRateData({
      datasets: datasetsReturnRate,
      returnRate: returnRate,
    });
    setAccuracyRateData({
      datasets: datasetsAccuracyRate,
      accuracyRate: accuracyRate,
    });
    setSafeStockRateData({
      datasets: datasetsSafeStockRate,
      safeStockRate: safeStockRate,
    });
    setTurnoverRatioData({
      datasets: datasetsTurnoverRatio,
      turnoverRatio: turnoverRatio,
    });
    setTotalStockCurrentValue(totalStockCurrentValue);
    setTotalProducts(totalProducts);
    setTotalAverageFulfillmentTime(totalAverageFulfillmentTime);
    setTotalAverageDaysToSell(totalAverageDaysToSell);
    setStockValueSummaryData(stockValueSummary.datasets);
    setOrderFulfillmentSummaryData(orderFulfillmentSummary.datasets);
    setStockQuantitySummaryData(stockQuantitySummary.datasets);
    setStockQuantitySummaryAmount({
      totalStockQuantity: stockQuantitySummary.totalStockQuantity,
    });
    setInventoryStatusSummaryData(inventoryStatusSummary.datasets);
    setInventoryStatusSummaryAmount({
      totalProduct: inventoryStatusSummary.totalProduct,
    });
    setTopStockValueSummaryData(topStockValueSummary.datasets);
    setTopStockReorderSummaryData(topStockReorderSummary.datasets);
    setTopStockQuantitySummaryData(topStockQuantitySummary.datasets);
    setInventoryTurnoverSummaryData(inventoryTurnoverSummary.datasets);
    setStockOpnameSummaryData(stockOpnameSummary.datasets);
  }

  async function getStockValueSummaryData(fiscalYearID = 0) {
    const response = await getStockValueSummary(fiscalYearID);
    const { data } = response.data;
    setStockValueSummaryData(data.stockValueSummary);
  }

  async function getOrderFulfillmentSummaryData(fiscalYearID = 0) {
    const response = await getOrderFulfillmentSummary(fiscalYearID);
    const { data } = response.data;
    setOrderFulfillmentSummaryData(data.orderFulfillmentSummary);
  }

  async function getTopStockValueSummaryData(fiscalPeriodID = 0) {
    const response = await getTopStockValueSummary(fiscalPeriodID);
    const { data } = response.data;
    setTopStockValueSummaryData(data.topStockValueSummary);
  }

  async function getTopStockReorderSummaryData(fiscalPeriodID = 0) {
    const response = await getTopStockReorderSummary(fiscalPeriodID);
    const { data } = response.data;
    setTopStockReorderSummaryData(data.topStockReorderSummary);
  }

  async function getTopStockQuantitySummaryData(fiscalPeriodID = 0) {
    const response = await getTopStockQuantitySummary(fiscalPeriodID);
    const { data } = response.data;
    setTopStockQuantitySummaryData(data.topStockQuantitySummary);
  }

  async function getInventoryTurnoverSummaryData(fiscalYearID = 0) {
    const response = await getInventoryTurnoverSummary(fiscalYearID);
    const { data } = response.data;
    setInventoryTurnoverSummaryData(data.inventoryTurnoverSummary);
  }

  async function getStockOpnameSummaryData(fiscalYearID = 0) {
    const response = await getStockOpnameSummary(fiscalYearID);
    const { data } = response.data;
    setStockOpnameSummaryData(data.stockOpnameSummary);
  }*/

  useEffect(() => {
    //getInventoryDashboardData(currentFiscalYear.ID, currentFiscalPeriod.ID);
  }, [reload]);

  return <React.Fragment></React.Fragment>;
}

export default ProductionDashboard;
